import { CMSMenuView } from '@modules/Nzo.CMS/Frontend/libraries/cmsMenu/cmsMenu.template'
import { NavItem } from '@shared/Frontend/components/navItems'
import React from 'react'

export const CMSMenu: CMSMenuView['CMSMenu'] = ({ items }) =>
  items.map(({ label, url, external, subNav }, index) => (
    <NavItem
      key={index}
      label={label}
      url={url}
      isActive={window.location.pathname === url}
      external={external}
      subNav={subNav}
      itemClassName="sh__navitem"
      linkClassName="sh__navlink"
    />
  ))
